"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organisation = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const country_entity_1 = require("./country.entity");
let Organisation = class Organisation {
    constructor(id, name, description, createdAt, updatedAt, createdBy, updatedBy) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
    }
};
exports.Organisation = Organisation;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Organisation.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "name", type: "varchar", length: 255 }),
    tslib_1.__metadata("design:type", String)
], Organisation.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "description", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], Organisation.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], Organisation.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Organisation.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Organisation.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], Organisation.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "country_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], Organisation.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => country_entity_1.Country),
    (0, typeorm_1.JoinColumn)({ name: "country_id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof country_entity_1.Country !== "undefined" && country_entity_1.Country) === "function" ? _e : Object)
], Organisation.prototype, "country", void 0);
exports.Organisation = Organisation = tslib_1.__decorate([
    (0, typeorm_1.Entity)("organisation"),
    tslib_1.__metadata("design:paramtypes", [Number, String, String, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, String, String])
], Organisation);
